import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoryRoutingModule } from './category-routing.module';
import { CategoryComponent } from './components/category/category.component';
import { MatChipsModule } from '@angular/material/chips';
import { HomeComponent } from './components/home/home.component';
import { MenuItemDirective } from '../shared/directive/menu-item.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule } from 'ng-lazyload-image';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { StaticComponent } from './components/static/static.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LazyLoadService } from '../shared/services/lazy-load.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { SearchComponent } from './components/search/search.component';
import { ProductListItemComponent } from './components/product-list-item/product-list-item.component';
import { CategoryListComponent } from './components/category-list/category-list.component';
import { ModuleHeaderComponent } from './components/home/components/module-header/module-header.component';

@NgModule({
  declarations: [
    HomeComponent,
    CategoryComponent,
    MenuItemDirective,
    ProductCardComponent,
    StaticComponent,
    SearchComponent,
    ProductListItemComponent,
    CategoryListComponent,
    ModuleHeaderComponent,
  ],
  imports: [
    CommonModule,
    MatChipsModule,
    CategoryRoutingModule,
    InfiniteScrollModule,
    LazyLoadImageModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    SlickCarouselModule,
    SharedModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatExpansionModule,
  ],
  providers: [{ provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadService }],
  exports: [ProductCardComponent],
})
export class CategoryModule {}
